export const BilimMerkezi = (props) => (
  <a
    href="https://www.konyabilimmerkezi.com/"
    aria-label="Bilim Merkezi Website linki"
    target="_blank"
    rel="noreferrer"
  >
    <svg viewBox="0 0 30.17 22.81" {...props}>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path
            className="cls-1"
            d="M1.6,22.22c0,.1-.02.18-.06.26-.04.07-.1.13-.17.18-.07.05-.16.09-.26.11-.1.03-.2.04-.31.04-.07,0-.15,0-.21-.01-.07,0-.14-.02-.2-.04-.06-.02-.13-.05-.19-.08-.06-.03-.13-.08-.19-.13l.26-.33c.09.07.17.12.26.15.09.03.17.05.26.05.06,0,.12,0,.16-.02.04-.01.08-.03.1-.05.03-.02.05-.04.06-.06.01-.02.02-.04.02-.06,0-.03,0-.05-.02-.07-.02-.02-.04-.04-.07-.06-.04-.02-.08-.04-.14-.06-.06-.02-.13-.04-.21-.06-.09-.02-.18-.05-.25-.08-.07-.03-.13-.07-.18-.12-.05-.04-.09-.1-.11-.16-.02-.06-.04-.13-.04-.22,0-.09.02-.17.05-.24.04-.07.09-.13.15-.18.06-.05.14-.09.23-.12.09-.03.19-.04.3-.04.12,0,.23.01.35.03.12.02.23.07.36.15l-.21.37c-.1-.06-.18-.1-.26-.11-.08-.02-.16-.02-.24-.02-.07,0-.13.01-.18.04-.05.02-.07.06-.07.12,0,.02,0,.05.02.07.02.02.04.04.07.06.03.02.08.04.14.06.06.02.13.04.21.06.13.03.23.07.31.12.08.04.14.09.18.14.04.05.07.11.08.16.01.06.02.12.02.18"
          />
          <path
            className="cls-1"
            d="M3.66,21.36c-.07-.05-.13-.09-.2-.11-.07-.02-.14-.03-.2-.03-.04,0-.08,0-.12.02-.04.01-.08.03-.11.05-.03.02-.06.06-.08.09-.02.04-.03.09-.03.14v.56c0,.06.01.1.03.14.02.04.05.07.08.09.03.02.07.04.11.05.04.01.08.02.12.02.06,0,.13,0,.19-.03.07-.02.14-.05.21-.11l.22.35c-.08.07-.18.12-.29.15-.11.03-.22.05-.34.05-.09,0-.19-.01-.28-.04-.1-.03-.18-.06-.26-.12-.07-.05-.13-.12-.18-.2-.05-.08-.07-.17-.07-.28v-.74c0-.11.02-.2.07-.28.05-.08.11-.14.18-.2.07-.05.16-.09.25-.12s.19-.04.28-.04c.12,0,.24.02.35.05.12.03.21.08.29.15l-.22.35Z"
          />
          <rect
            className="cls-1"
            x="4.79"
            y="20.83"
            width=".46"
            height="1.97"
          />
          <polygon
            className="cls-1"
            points="6.24 20.83 7.65 20.83 7.65 21.23 6.71 21.23 6.71 21.6 7.51 21.6 7.51 22 6.71 22 6.71 22.39 7.65 22.39 7.65 22.79 6.24 22.79 6.24 20.83"
          />
          <polygon
            className="cls-1"
            points="9 21.66 9 22.79 8.54 22.79 8.54 20.83 8.95 20.83 9.29 21.3 9.73 21.96 9.74 21.96 9.74 20.83 10.2 20.83 10.2 22.79 9.79 22.79 9.37 22.19 9.01 21.66 9 21.66"
          />
          <path
            className="cls-1"
            d="M12.33,21.36c-.07-.05-.13-.09-.2-.11-.07-.02-.14-.03-.2-.03-.04,0-.08,0-.12.02-.04.01-.07.03-.11.05-.03.02-.06.06-.08.09-.02.04-.03.09-.03.14v.56c0,.06.01.1.03.14.02.04.05.07.08.09.03.02.07.04.11.05.04.01.08.02.12.02.06,0,.13,0,.19-.03.07-.02.14-.05.21-.11l.22.35c-.08.07-.18.12-.29.15-.11.03-.22.05-.34.05-.09,0-.19-.01-.28-.04-.09-.03-.18-.06-.25-.12-.07-.05-.14-.12-.18-.2-.05-.08-.07-.17-.07-.28v-.74c0-.11.02-.2.07-.28.05-.08.11-.14.18-.2s.16-.09.25-.12.19-.04.28-.04c.12,0,.23.02.35.05.11.03.21.08.29.15l-.22.35Z"
          />
          <polygon
            className="cls-1"
            points="13.4 20.83 14.81 20.83 14.81 21.23 13.86 21.23 13.86 21.6 14.67 21.6 14.67 22 13.86 22 13.86 22.39 14.81 22.39 14.81 22.79 13.4 22.79 13.4 20.83"
          />
          <path
            className="cls-1"
            d="M18.24,21.36c-.07-.05-.13-.09-.2-.11-.07-.02-.13-.03-.2-.03-.04,0-.08,0-.12.02-.04.01-.07.03-.11.05-.03.02-.06.06-.08.09-.02.04-.03.09-.03.14v.56c0,.06.01.1.03.14.02.04.05.07.08.09.03.02.07.04.11.05.04.01.08.02.12.02.06,0,.13,0,.19-.03.07-.02.14-.05.21-.11l.22.35c-.08.07-.18.12-.29.15-.11.03-.22.05-.34.05-.09,0-.19-.01-.28-.04-.1-.03-.18-.06-.25-.12-.07-.05-.13-.12-.18-.2-.05-.08-.07-.17-.07-.28v-.74c0-.11.02-.2.07-.28.04-.08.11-.14.18-.2s.16-.09.25-.12c.09-.03.19-.04.28-.04.12,0,.23.02.35.05.12.03.21.08.29.15l-.22.35Z"
          />
          <polygon
            className="cls-1"
            points="19.31 20.83 20.71 20.83 20.71 21.23 19.77 21.23 19.77 21.6 20.57 21.6 20.57 22 19.77 22 19.77 22.39 20.71 22.39 20.71 22.79 19.31 22.79 19.31 20.83"
          />
          <polygon
            className="cls-1"
            points="22.07 21.66 22.07 22.79 21.6 22.79 21.6 20.83 22.02 20.83 22.35 21.3 22.79 21.96 22.8 21.96 22.8 20.83 23.27 20.83 23.27 22.79 22.85 22.79 22.44 22.19 22.08 21.66 22.07 21.66"
          />
          <polygon
            className="cls-1"
            points="25.03 21.23 25.03 22.79 24.56 22.79 24.56 21.23 24.05 21.23 24.05 20.83 25.54 20.83 25.54 21.23 25.03 21.23"
          />
          <polygon
            className="cls-1"
            points="26.32 20.83 27.73 20.83 27.73 21.23 26.79 21.23 26.79 21.6 27.59 21.6 27.59 22 26.79 22 26.79 22.39 27.73 22.39 27.73 22.79 26.32 22.79 26.32 20.83"
          />
          <path
            className="cls-1"
            d="M29.08,21.67h.35c.09,0,.15-.02.18-.06.04-.04.06-.1.06-.16s-.02-.11-.06-.16c-.04-.04-.1-.06-.18-.06h-.35v.44ZM29.52,20.83c.11,0,.2.02.28.05.08.04.14.08.19.14.05.06.09.13.11.2.02.07.03.15.03.23,0,.05,0,.1-.02.15-.02.05-.04.1-.06.15-.03.05-.06.09-.1.13-.04.04-.09.07-.14.1l.36.8h-.5l-.3-.73h-.29v.73h-.46v-1.97h.9Z"
          />
          <polygon
            className="cls-1"
            points="10.9 15.02 10.32 15.02 9.4 13.45 8.85 14.1 8.85 15.02 8.36 15.02 8.36 11.84 8.85 11.84 8.85 13.44 10.18 11.84 10.79 11.84 9.73 13.09 10.9 15.02"
          />
          <path
            className="cls-1"
            d="M13.5,13.43c0,.25,0,.44-.02.58,0,.13-.04.26-.08.38-.05.12-.12.22-.21.32-.23.23-.52.34-.86.34s-.62-.11-.86-.34c-.1-.1-.17-.21-.22-.32-.05-.11-.07-.24-.08-.37-.01-.14-.02-.33-.02-.58,0-.19,0-.35,0-.46,0-.11.02-.22.04-.31.02-.09.05-.18.09-.26.04-.08.1-.16.18-.24.23-.23.52-.34.86-.34s.63.11.86.34c.1.1.17.21.21.33.04.12.07.24.08.37.01.13.02.33.02.58M13,13.43c0-.32-.01-.54-.04-.67-.02-.13-.08-.24-.15-.32-.06-.06-.13-.11-.22-.14-.09-.04-.18-.05-.27-.05s-.19.02-.27.05c-.09.04-.16.08-.21.14-.08.09-.13.19-.16.32-.02.13-.04.35-.04.67,0,.17,0,.3,0,.41,0,.1.02.19.03.26.02.08.03.13.05.18.02.04.05.09.1.14.06.06.13.11.22.14.09.04.18.05.27.05.2,0,.36-.07.48-.2.05-.06.09-.12.12-.19.03-.07.05-.17.06-.3.01-.12.02-.29.02-.5"
          />
          <polygon
            className="cls-1"
            points="16.54 15.02 16.09 15.02 14.59 12.78 14.59 15.02 14.09 15.02 14.09 11.84 14.54 11.84 16.05 14.08 16.05 11.84 16.54 11.84 16.54 15.02"
          />
          <polygon
            className="cls-1"
            points="19.39 11.84 18.41 13.71 18.41 15.02 17.92 15.02 17.92 13.71 16.95 11.84 17.48 11.84 18.17 13.24 18.85 11.84 19.39 11.84"
          />
          <path
            className="cls-1"
            d="M22.09,15.02h-.53l-.22-.64h-1.29l-.22.64h-.53l1.19-3.18h.4l1.19,3.18ZM21.21,13.97l-.49-1.41-.51,1.41h1Z"
          />
          <path
            className="cls-1"
            d="M12.88,8.86h-3.12l.36-.16v-.33l1.86-.13.91.62ZM13.12,8.15c-.04.11-.06.23-.08.35l-.48-.31.56-.04ZM13.32,7.7s-.04.08-.07.12l-1.16.08-1.51-.98.19-.35-.35-.46.59.07.17-.31,1.6.79.53,1.05ZM13.79,7.14c-.09.08-.17.16-.25.25l-.24-.49.48.24ZM14.24,6.83s-.1.05-.14.08l-1.02-.5-.8-1.64.31-.21-.05-.49.43.32.36-.18.98,1.44-.07,1.17ZM14.94,6.59c-.12.02-.24.05-.36.09l.05-.56.31.46ZM15.48,6.56s-.08,0-.12,0h-.04l-.65-.96.14-1.75h.3s.26-.45.26-.45l.32.44h.3s.14,1.76.14,1.76l-.65.96ZM16.22,6.72c-.12-.05-.24-.08-.37-.11l.32-.48.05.59ZM16.66,6.94s-.06-.04-.1-.06l-.08-1.22.98-1.44.36.18.43-.32-.05.49.31.21-.8,1.64-1.07.52ZM17.22,7.45c-.08-.1-.17-.2-.27-.29l.54-.26-.27.55ZM17.45,7.81l-.02-.03.57-1.13,1.61-.79.17.31.59-.07-.35.46.2.35-1.51.98-1.25-.09ZM17.69,8.56c-.02-.14-.05-.28-.09-.41l.65.05-.56.36ZM21.05,8.86h-3.15l.94-.62,1.86.14v.33l.36.15ZM20.92,6.04c.23.61.35,1.28.35,1.97,0,.18,0,.36-.03.54l-.24-.1v-.39l-1.72-.12,1.43-.93-.22-.43.37-.53h.05ZM19.04,3.49c.72.57,1.31,1.3,1.7,2.13l-.06.08-.69.09-.18-.4-1.55.76.74-1.45-.4-.27.06-.66.38-.28ZM15.79,2.25c.93.07,1.8.34,2.56.78l-.05.51-.56.41-.39-.19-.91,1.36-.1-1.62h-.45l-.35-.68.24-.57ZM12.44,2.98c.77-.43,1.64-.69,2.57-.74l.24.57-.35.68h-.45l-.1,1.62-.91-1.36-.39.19-.55-.39-.05-.58ZM10.01,5.55c.4-.82.98-1.54,1.71-2.1l.36.27.12.71-.4.27.74,1.45-1.55-.76-.18.4-.69-.09-.11-.15ZM9.45,8.01c0-.69.13-1.36.36-1.98h.13s.37.55.37.55l-.22.43,1.43.93-1.72.12v.39l-.32.14c-.02-.19-.03-.38-.03-.58"
          />
          <path
            className="cls-1"
            d="M13.24,8.85c0-1.14.95-2.07,2.12-2.07s2.11.93,2.11,2.07c0,.35-.09.67-.24.96-.45-.53-1.12-.86-1.87-.86s-1.43.34-1.88.86c-.15-.29-.24-.61-.24-.96"
          />
          <path
            className="cls-1"
            d="M8.83,6.38c0-3.53,2.92-6.38,6.53-6.38s6.53,2.86,6.53,6.38c0,.79-.15,1.54-.41,2.24.02-.2.03-.41.03-.62,0-3.32-2.75-6.01-6.15-6.01s-6.15,2.69-6.15,6.01c0,.21.01.41.03.62-.27-.7-.41-1.45-.41-2.24"
          />
          <path
            className="cls-1"
            d="M15.26,10.92c-.25-.01-.49-.06-.71-.15v-.04s.41-.21.41-.21l.3.4Z"
          />
          <path
            className="cls-1"
            d="M16.25,10.73c-.21.1-.44.16-.68.18l.26-.4.42.21h0Z"
          />
          <path
            className="cls-1"
            d="M17.04,10.07c-.11.18-.26.33-.43.45v-.42s.43-.03.43-.03Z"
          />
          <path
            className="cls-1"
            d="M13.66,10.09h.52s.03.43.03.43l-.06.03c-.19-.13-.35-.28-.48-.46"
          />
          <path
            className="cls-1"
            d="M13.97,9.77c.37-.32.86-.51,1.39-.51s1.02.19,1.39.51l-.42.03-.05.56-.53-.26-.33.45-.38-.45-.53.26-.04-.56-.5-.04Z"
          />
          <path
            className="cls-1"
            d="M2.44,18.56c0,.15-.03.28-.08.4-.05.12-.12.21-.21.3-.09.08-.2.14-.32.18-.13.04-.26.06-.4.06H0v-3.18h1.35c.22,0,.41.04.56.12.16.07.27.18.35.32.08.14.12.3.12.48,0,.15-.04.28-.12.39-.08.1-.16.18-.24.24.11.06.2.14.28.25.08.1.12.25.12.44M1.6,17.27c0-.07-.02-.13-.07-.18-.04-.05-.12-.08-.22-.08h-.5v.52h.5c.1,0,.17-.03.22-.08.05-.05.07-.11.07-.18M1.64,18.51c0-.08-.02-.14-.07-.2-.05-.05-.12-.08-.22-.08h-.54v.56h.54c.1,0,.17-.03.22-.08.05-.06.07-.12.07-.2"
          />
          <rect className="cls-1" x="2.9" y="17.18" width=".75" height="2.31" />
          <polygon
            className="cls-1"
            points="6.39 19.49 4.22 19.49 4.22 16.31 5.02 16.31 5.02 18.8 6.39 18.8 6.39 19.49"
          />
          <rect
            className="cls-1"
            x="6.72"
            y="17.18"
            width=".75"
            height="2.31"
          />
          <polygon
            className="cls-1"
            points="10.93 19.49 10.13 19.49 10.13 17.97 9.67 18.76 9.16 18.76 8.7 17.97 8.7 19.49 7.9 19.49 7.9 16.31 8.68 16.31 9.41 17.72 10.15 16.31 10.93 16.31 10.93 19.49"
          />
          <polygon
            className="cls-1"
            points="15.55 19.49 14.75 19.49 14.75 17.97 14.29 18.76 13.78 18.76 13.32 17.97 13.32 19.49 12.52 19.49 12.52 16.31 13.3 16.31 14.03 17.72 14.77 16.31 15.55 16.31 15.55 19.49"
          />
          <polygon
            className="cls-1"
            points="18.15 19.49 15.94 19.49 15.94 16.31 18.15 16.31 18.15 17.01 16.74 17.01 16.74 17.54 17.94 17.54 17.94 18.24 16.74 18.24 16.74 18.8 18.15 18.8 18.15 19.49"
          />
          <path
            className="cls-1"
            d="M21.11,19.49h-.93l-.57-1.19h-.27v1.19h-.8v-3.18h1.29c.23,0,.43.05.6.14.17.09.29.22.38.37.09.16.13.32.13.51,0,.2-.05.37-.15.51-.1.14-.23.25-.38.32l.7,1.33ZM20.13,17.34c0-.06-.01-.11-.04-.16-.03-.05-.07-.09-.12-.12-.05-.03-.11-.05-.18-.05h-.45v.64h.45c.07,0,.13-.02.18-.04.05-.03.09-.07.12-.12.03-.05.04-.1.04-.16"
          />
          <polygon
            className="cls-1"
            points="24.03 19.49 23.1 19.49 22.35 18.19 22.08 18.5 22.08 19.49 21.28 19.49 21.28 16.31 22.08 16.31 22.08 17.44 23.02 16.31 24 16.31 22.88 17.6 24.03 19.49"
          />
          <polygon
            className="cls-1"
            points="26.48 19.49 24.27 19.49 24.27 16.31 26.48 16.31 26.48 17.01 25.07 17.01 25.07 17.54 26.28 17.54 26.28 18.24 25.07 18.24 25.07 18.8 26.48 18.8 26.48 19.49"
          />
          <polygon
            className="cls-1"
            points="29.02 19.49 26.81 19.49 26.81 18.89 28.06 17.01 26.87 17.01 26.87 16.31 29.02 16.31 29.02 16.92 27.76 18.8 29.02 18.8 29.02 19.49"
          />
          <rect
            className="cls-1"
            x="29.35"
            y="17.18"
            width=".75"
            height="2.31"
          />
          <rect className="cls-1" x="2.9" y="16.31" width=".75" height=".68" />
          <rect className="cls-1" x="6.72" y="16.31" width=".75" height=".68" />
          <rect
            className="cls-1"
            x="29.35"
            y="16.31"
            width=".75"
            height=".68"
          />
        </g>
      </g>
    </svg>
  </a>
);
